$(function () {
    var $expandButton = $(".mobile-collapse-button"),
        $panel = $(".mobile-collapse-content"),
        mobileWidth = "767px",
        resizeTimer;

    $expandButton.on("click", function () {

        if (Modernizr.mq("(max-width: " + mobileWidth + ")")) {
            $expandButton.toggleClass("active");
            $panel.slideToggle(400);
        }
    });

    $(window).on("resize", function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
            if (Modernizr.mq("(min-width: " + mobileWidth + ")")) {
                $panel.show();
            } else if (Modernizr.mq("(max-width: " + mobileWidth + ")")) {
                if (!$expandButton.hasClass("active")) {
                    $panel.hide();
                }
            }
        }, 100);
    });
});
